import { observer } from 'mobx-react-lite'
import { Alert, Button, Label } from 'shared/ui'
import { DefaultModalActions } from 'shared/ui/Modal/ui/DefaultModal/DefaultModalActions'
import { InputNumeric, TextField } from 'shared/ui/TextField'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'
import { type RemoveSeats } from '../store/RemoveSeats'

export const RemoveSeatsUi = observer(({ store }: { store: RemoveSeats }) => {
  const { onBack, seats, setSeats, onRemove, requestRemoveSeatsInfoStatus } = store

  const { subscriptionStore } = useEntitiesContext()
  const { seatsAvailable } = subscriptionStore

  const isAllowed = ({ floatValue }: { floatValue?: number }) => {
    return !floatValue || floatValue <= seatsAvailable
  }

  const onBlur = () => {
    if (!seats) {
      setSeats('1')
    }
  }

  return (
    <>
      {requestRemoveSeatsInfoStatus.status.error && (
        <Alert
          marginInline={24}
          marginBottom={24}
          item={{
            type: 'alert',
            desc: requestRemoveSeatsInfoStatus.status.error,
          }}
        />
      )}
      <Alert
        marginInline={24}
        marginBottom={24}
        item={{
          type: 'warning',
          title: `Your workspace has ${seatsAvailable} empty seat${
            seatsAvailable !== 1 ? 's' : ''
          } available for removal`,
          desc: `The seat${
            seatsAvailable !== 1 ? 's' : ''
          } will be removed immediately. Any billing updates will be reflected in the next billing cycle.`,
        }}
      />
      <div className={styles.input}>
        <Label
          label={{
            text: 'Number of seats you want to remove',
          }}
        />
        <TextField
          Input={InputNumeric}
          variant={'stroke'}
          size={'large'}
          InputProps={{
            isAllowed,
            allowNegative: false,
          }}
          onBlur={onBlur}
          value={seats}
          onChange={setSeats}
        />
      </div>

      <DefaultModalActions>
        <Button text={'Back'} onClick={onBack} size={'medium'} contained={'secondary'} />
        <Button
          text={`Remove ${seats || ''} seat${Number(seats) > 1 ? 's' : ''}`}
          onClick={onRemove}
          loading={requestRemoveSeatsInfoStatus.status.isLoading}
          size={'medium'}
          contained={'primary'}
          disabled={!seats}
        />
      </DefaultModalActions>
    </>
  )
})
